import {
  ALL_FACILITIES,
  useSelectedFacilityId
} from '@/hooks/useFacilitiesQuery';
import { ExacareFeature, FeatureFlagService } from '@/utils/featureFlagService';

import {
  ScreenerSettingName,
  useScreenerSettingsQuery
} from './useScreenerSettingsQuery';

export function useIsReferralOutboundEnabled(
  overrideFacilityId?: string
): boolean | undefined {
  const selectedFacilityId = useSelectedFacilityId();
  const facilityId =
    overrideFacilityId ??
    (typeof selectedFacilityId === 'string' &&
    selectedFacilityId !== ALL_FACILITIES
      ? selectedFacilityId
      : undefined);

  const { data, isLoading } = useScreenerSettingsQuery().useFindOneByFacilityId(
    {
      facilityId: facilityId ?? '',
      settingName: ScreenerSettingName.ReferralOutbound
    },
    {
      enabled: Boolean(facilityId)
    }
  );

  if (!FeatureFlagService.isEnabled(ExacareFeature.CRM_REFERRAL_OUTBOUND)) {
    return false;
  }

  if (isLoading) {
    return undefined;
  }

  if (!facilityId) {
    return false;
  }

  return data?.data?.value === 'enabled';
}
